var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ReportTemplate',{attrs:{"loading":!_vm.initialized,"title":"Inventory Transfer Report","filters":_vm.filters,"permission":_vm.PERMISSION_CODES.CMS_VIEW_REPORT_INVENTORY_TRANSFER,"columns":_vm.columns,"fetchRoute":"/reports/inventory-transfers","reportTypeCode":_vm.REPORT_MASTER_CODES.INVENTORY_TRANSFER}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }